import script from "./OrganizationsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationsList.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationsList.vue?vue&type=style&index=0&id=21561da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21561da0"]])

export default __exports__